<div
  ngbDropdown
  class="notification-button"
  [class.open]="isOpen"
  (openChange)="toggleNotificationCenter($event)"
  #notificationDropdown="ngbDropdown"
>
  <button
    class="dropdown-toggle notification-btn btn border-0"
    id="notificationDropdown"
    attr.aria-label="{{ 'nav.notification.screenreader' | translate }}"
    tabindex="-1"
    ngbDropdownToggle
  >
    <span class="notification-icon">
      <span class="icon notification-bell text-white material-icons material-mobile-nav" aria-hidden="true">notifications</span>
      <ng-container *ngIf="unseenNotificationCount$ | async">
        <span class="notification-badge">
          <div class="count-notification">{{ unseenNotificationCount$ | async }}</div>
        </span>
      </ng-container>
    </span>
  </button>

  <div ngbDropdownMenu aria-labelledby="notificationDropdown" class="notification-dropdown dropdown-menu p-0">
    <div class="notification-header d-flex">
      <div class="font-page-heading text-black font-size-14 text-uppercase">
        {{ 'navbar.notifications.title' | translate : { fgbdefault: 'Notifications' } }}
      </div>
      <i class="material-icons close-btn text-info" (click)="notificationDropdown.close()"></i>
    </div>
    <fgbcl-notification-hub (goToNotification)="closeDropDown(notificationDropdown)"></fgbcl-notification-hub>
  </div>
  <div class="notification-mobile-backdrop"></div>
</div>
